import { render, staticRenderFns } from "./EducationTestArchive.vue?vue&type=template&id=15a210fe&"
import script from "./EducationTestArchive.vue?vue&type=script&lang=js&"
export * from "./EducationTestArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports